

import  {defineComponent, onMounted, ref} from "vue";
import WhiteBoxMain from '@/components/WhiteBoxMain.vue';
import {reviewRequest} from '@/core/constants';
import {
  getApprovedRequests,
  PartnerReviewRequestResource
} from '@/api/partnerReviewApi';
import RequestPartnerListFilter from '@/components/RequestPartnerListFilter.vue';
import PartnerRequestApprovedListItem from '@/components/PartnerRequestApprovedListItem.vue';

export default defineComponent( {
  name: 'RequestApprovedPage',
  components: { PartnerRequestApprovedListItem, RequestPartnerListFilter, WhiteBoxMain},
  setup() {
    const approvedRequest = ref<PartnerReviewRequestResource[]>([])

    const filterBy = ref('7d');
    function setFilter(field: string) {
      filterBy.value = field;
      getApprovedRequestsAction(field)
    }

    onMounted(() => {
      getApprovedRequestsAction(filterBy.value)
    })

    const getApprovedRequestsAction = (filter:string) => {
      getApprovedRequests(filter).then(res => {
        approvedRequest.value = res;
      })
    }

    return {
      approvedRequest,
      setFilter,
      filterBy,
    }
  },
methods: { reviewRequest() {
return reviewRequest} }

});
